"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../../Utilities");
var ShimmerCircle_styles_1 = require("./ShimmerCircle.styles");
var ShimmerCircle_base_1 = require("./ShimmerCircle.base");
exports.ShimmerCircle = Utilities_1.styled(ShimmerCircle_base_1.ShimmerCircleBase, ShimmerCircle_styles_1.getStyles);
//# sourceMappingURL=ShimmerCircle.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib/components/Shimmer/ShimmerCircle/ShimmerCircle.js
// module id = 827
// module chunks = 0